var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoFeatures = function SvgVideoFeatures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "M31.867 28.443v.8H21.629v-.8zm0-4.719v.8H21.629v-.8zm0-4.719v.8H21.629v-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M21.298 1.045A15.87 15.87 0 0 1 31.865 15.77l.002.226v.4h-.8v-.4a15.066 15.066 0 1 0-12.17 14.789l.22-.045.392-.083.165.783-.391.082a15.867 15.867 0 1 1 2.015-30.477M11.144 9.813l10.66 5.922-10.66 5.923zm.8 1.359v9.126l8.213-4.563-8.214-4.563Z"
  }))));
};
export default SvgVideoFeatures;